import { Modal } from '../Modal';
import { StatusMessage } from '../StatusMessage';
type Props = {
  buttonsChildren: JSX.Element;
  className?: string;
  description?: string;
  logoStatus: 'ok' | 'sad' | 'smile' | 'successful';
  onOpenChange: (open: boolean) => void;
  open: boolean;
  richText?: Record<string, unknown>[];
};
export const StatusModal = ({
  buttonsChildren,
  className,
  description,
  logoStatus,
  onOpenChange,
  open,
  richText
}: Props) => {
  return <Modal className={className} isPopup onOpenChange={onOpenChange} open={open} stopPropagation={true} data-sentry-element="Modal" data-sentry-component="StatusModal" data-sentry-source-file="StatusModal.tsx">
      <StatusMessage buttonsChildren={buttonsChildren} description={description} logoStatus={logoStatus} richText={richText} data-sentry-element="StatusMessage" data-sentry-source-file="StatusModal.tsx" />
    </Modal>;
};